/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDictionaryTypeDto
 */
export interface GetDictionaryTypeDto {
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryTypeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryTypeDto
     */
    name: string;
}

/**
 * Check if a given object implements the GetDictionaryTypeDto interface.
 */
export function instanceOfGetDictionaryTypeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function GetDictionaryTypeDtoFromJSON(json: any): GetDictionaryTypeDto {
    return GetDictionaryTypeDtoFromJSONTyped(json, false);
}

export function GetDictionaryTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDictionaryTypeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function GetDictionaryTypeDtoToJSON(value?: GetDictionaryTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

